<div *ngIf="suggestions?.length" class="suggestion-banner" [class.compact]="compact">
  <div class="suggestion-banner__header" *ngIf="!compact">
    <i class="bi bi-lightbulb-fill"></i>
    <span>{{ suggestions.length }} pending product suggestion{{ suggestions.length > 1 ? 's' : '' }}</span>
  </div>

  <div
    *ngFor="let s of suggestions; trackBy: trackById"
    class="suggestion-card"
  >
    <div class="suggestion-card__row">
      <div class="suggestion-card__products">
        <span class="product-chip product-chip--prev" [title]="s.previousProduct?.sku">
          <span class="product-chip__label">Current</span>
          <span class="product-chip__name">{{ s.previousProduct?.name || s.previousProduct?.sku || '—' }}</span>
        </span>
        <i class="bi bi-arrow-right suggestion-card__arrow"></i>
        <span class="product-chip product-chip--next" [title]="s.suggestedProduct?.sku">
          <span class="product-chip__label">Suggested</span>
          <span class="product-chip__name">{{ s.suggestedProduct?.name || s.suggestedProduct?.sku || '—' }}</span>
        </span>
      </div>

      <div class="suggestion-card__meta">
        <a
          *ngIf="shopifyOrderHref(s.shopifyOrderId)"
          [href]="shopifyOrderHref(s.shopifyOrderId)"
          target="_blank"
          class="meta-pill"
          title="Open Shopify order"
        >
          <i class="bi bi-cart"></i>
          <ng-container *ngIf="s.shopifyOrderNumber">#{{ s.shopifyOrderNumber }}</ng-container>
          <ng-container *ngIf="!s.shopifyOrderNumber">{{ s.shopifyOrderId }}</ng-container>
        </a>
        <span class="meta-pill meta-pill--email" *ngIf="!compact && s.email" [title]="s.email">
          <i class="bi bi-person"></i> {{ s.email }}
        </span>
        <span class="meta-pill meta-pill--date" *ngIf="s.dates?.entered">
          <i class="bi bi-clock"></i> {{ s.dates.entered | date: 'MMM d, h:mm a' }}
        </span>
      </div>

      <div class="suggestion-card__actions">
        <button
          type="button"
          class="btn btn-sm btn-success"
          (click)="apply(s)"
          [disabled]="busyId === s._id"
        >
          <em class="spinner-border spinner-border-sm me-1" *ngIf="busyId === s._id && busyAction === 'applying'"></em>
          <i class="bi bi-check-lg" *ngIf="!(busyId === s._id && busyAction === 'applying')"></i>
          Apply
        </button>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          (click)="dismiss(s)"
          [disabled]="busyId === s._id"
        >
          <em class="spinner-border spinner-border-sm me-1" *ngIf="busyId === s._id && busyAction === 'dismissing'"></em>
          <i class="bi bi-x-lg" *ngIf="!(busyId === s._id && busyAction === 'dismissing')"></i>
          Dismiss
        </button>
        <button
          type="button"
          class="btn btn-sm btn-link suggestion-card__toggle"
          (click)="toggleReasoning(s._id)"
          *ngIf="s.reasoning?.length"
          [title]="expanded[s._id] ? 'Hide reasoning' : 'Show reasoning'"
        >
          <i class="bi" [class.bi-chevron-up]="expanded[s._id]" [class.bi-chevron-down]="!expanded[s._id]"></i>
        </button>
      </div>
    </div>

    <div *ngIf="errorByItem[s._id]" class="suggestion-card__error">
      <i class="bi bi-exclamation-triangle"></i> {{ errorByItem[s._id] }}
    </div>

    <div *ngIf="expanded[s._id] && s.reasoning?.length" class="suggestion-card__reasoning">
      <div *ngFor="let line of s.reasoning" class="reasoning-line">{{ line }}</div>
    </div>
  </div>
</div>
